import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import ProductTableRow from "./product-table-row";
import { Product } from "../../../../service/model/store.model";
import { configs } from "../../../../app/app-configs";

const headers: ColumnHeader[] = [
    { name: "Name" },
    { name: "Description" },
    { name: "Stock Available" },
    { name: "Low Stock Threshold" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly products: Product[]
}

const ProductTable: React.FC<TableProps> = ({ products }) => {

    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(products.length / configs.PAGE_SIZE);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            onPageChange={handlePageChange}>

            {(configs.PAGE_SIZE > 0
                ? products.slice((page - 1) * configs.PAGE_SIZE, (page - 1) * configs.PAGE_SIZE + configs.PAGE_SIZE)
                : products
            )?.map(product =>
                <ProductTableRow product={product} key={product.id} />
            )}
        </StyledTable>
    );
}

export default ProductTable;